import React from 'react';

import { appReactMemo } from 'hocs';

import { typographyTheme } from './theme';

export interface ITypography {
  as?: keyof typeof typographyTheme;
  children: React.ReactNode | React.ReactNode[];
  className?: string;
  id?: string;
  onClick?: (e: React.SyntheticEvent) => void;
  size?: ITypographySizes;
  testIds?: { root?: string };
  textRef?: React.RefObject<HTMLDivElement | HTMLHeadingElement | null>;
  variant?: 'bold' | 'regular';
}

export type ITypographySizes = 'lg' | 'md' | 'sm' | 'xl' | 'xs' | 'xxl' | 'xxs';

const Text = ({
  as = 'p',
  children,
  className,
  id,
  onClick,
  testIds,
  textRef,
}: ITypography) => {
  const Component = as === 'p' ? 'div' : as;

  return (
    <Component
      className={className}
      data-testid={testIds?.root}
      id={id}
      onClick={onClick}
      ref={textRef}
    >
      {children}
    </Component>
  );
};

export default appReactMemo(Text);
